// Vietnamese translations
export const vi = {
  // Header
  header: {
    searchPlaceholder: "Tìm kiếm người nổi tiếng, sản phẩm, livestream, video, cửa hàng hoặc thương hiệu",
    search: "Tìm kiếm",
    trialVersion: "Phiên bản dùng thử",
    upgradeTrial: "Mua gói",
    loginRegister: "Đăng nhập/Đăng ký",
    downloadApp: "Tải App",
  },

  // Products page
  products: {
    title: "Bảng sản phẩm",
    collapseMore: "Thu gọn thêm bảng",
    expandMore: "Mở rộng thêm bảng",
    description: "Sắp xếp theo dữ liệu bán hàng của sản phẩm trên Douyin, nhanh chóng tìm thấy sản phẩm bán chạy trong toàn bộ thị trường",
    all: "Tất cả",
    advancedFilter: "Lọc nâng cao",
    price: "Giá",
    custom: "Tùy chỉnh",
    yuan: "VNĐ",
    to: "đến",
    confirm: "Xác nhận",
    brand: "Thương hiệu",
    selectBrand: "Chọn thương hiệu",
    livePromotion: "Quảng bá livestream",
    lowPriceTraffic: "Giá thấp thu hút",
    export: "Xuất",
    rank: "Xếp hạng",
    product: "Sản phẩm",
    productImage: "Hình sản phẩm",
    douyinSales: "Doanh số Douyin",
    douyinSalesAmount: "Doanh thu Douyin",
    relatedCreators: "Số người sáng tạo liên quan",
    relatedLiveStreams: "Số livestream liên quan",
    relatedVideos: "Số video liên quan",
    commissionRate: "Tỷ lệ hoa hồng",
    action: "Thao tác",
    discoveryTime: "Thời gian phát hiện",
    days: "ngày",
    noProductsFound: "Không tìm thấy sản phẩm",
    loadingProducts: "Đang tải sản phẩm...",
    tableColumns: {
      rank: "Xếp hạng",
      product: "Sản phẩm",
      shop: "Cửa hàng",
      cardSales: "Lượng bán thẻ sản phẩm",
      cardGmv: "Doanh thu thẻ sản phẩm",
      commissionRate: "Tỷ lệ hoa hồng",
      action: "Thao tác",
    },
    tableColumnsAweme: {
      rank: "Xếp hạng",
      productInfo: "Thông tin sản phẩm",
      shopInfo: "Thông tin cửa hàng",
      videoSalesVolume: "Lượng bán video",
      videoSalesAmount: "Doanh thu video",
      commissionRate: "Tỷ lệ hoa hồng",
      estimatedCommission: "Hoa hồng ước tính",
      action: "Thao tác",
    },
  },

  // Ranking tabs
  rankingTabs: {
    topHotProducts: "Top sản phẩm HOT",
    douyinProducts: "Bảng sản phẩm Douyin",
    videoProducts: "Bảng sản phẩm video",
    productCardHot: "Bảng sản phẩm thẻ bán chạy",
  },

  topVideos: {
    title: "Top Video Sản phẩm HOT",
    description: "Top video sản phẩm bán chạy nhất trên Douyin, cập nhật hàng ngày",
    noData: "Chưa có video nào cho ngày này",
    processing: "Đang xử lý",
    position: "Hạng",
    loading: "Đang tải video...",
    error: "Không thể tải danh sách video",
    retry: "Thử lại",
  },

  weeklyVideos: {
    title: "Top 200 Video Tuần",
    description: "Danh sách 200 video sản phẩm hot nhất, cập nhật hàng tuần",
    noData: "Chưa có video cho tuần này",
    processing: "Đang xử lý",
    error: "Không thể tải dữ liệu",
    retry: "Thử lại",
  },

  // Date types
  dateTypes: {
    daily: "Hôm nay",
    weekly: "Bảng tuần",
    monthly: "Bảng tháng",
    yearly: "Bảng năm",
    festival: "Lễ hội lớn",
  },

  // Price ranges
  priceRanges: {
    all: "Tất cả",
    range1: "1-50",
    range2: "50-100",
    range3: "100-300",
    range4: "300-500",
    range5: "500-1000",
    range6: ">1000",
  },

  // Category Modal
  categoryModal: {
    title: "Phân loại sản phẩm",
    searchPlaceholder: "Vui lòng nhập từ khóa để tìm kiếm danh mục sản phẩm",
    all: "Tất cả",
    lastSelection: "Lựa chọn trước",
    reset: "Đặt lại",
    confirm: "Xác nhận",
    search: "Tìm kiếm",
  },

  // Sidebar
  sidebar: {
    dashboard: "Bàn làm việc",
    industry: "Ngành",
    creators: "Người sáng tạo",
    liveStream: "Livestream",
    productLibrary: "Thư viện sản phẩm",
    productRanking: "Bảng sản phẩm",
    trendingVideos: "Video Trending",
    weeklyVideos: "Top 200 Video Tuần",
    shop: "Cửa hàng",
    brand: "Thương hiệu",
    blog: "Blog",
    monitor: "Giám sát",
    advertising: "Quảng cáo",
    localLife: "Đời sống địa phương",
    toolbox: "Hộp công cụ",
    membershipPlans: "Gia hạn các gói",
    customerService: "Dịch vụ khách hàng trực tuyến",
    workflow: "Workflow",
    workflowUser: "Quy trình người dùng",
  },

  // Shops page
  shops: {
    title: "Bảng xếp hạng cửa hàng",
    shopLogo: "Logo cửa hàng",
    rankingTabs: {
      salesRanking: "Bảng xếp hạng doanh số cửa hàng",
      regionalRanking: "Bảng xếp hạng cửa hàng theo khu vực",
    },
    tableColumns: {
      rank: "Xếp hạng",
      shop: "Cửa hàng",
      avgPrice: "Giá trung bình",
      salesVolume: "Lượng bán",
      salesAmount: "Doanh thu",
      influencerCount: "Số người ảnh hưởng liên quan",
    },
  },

  // Product Library
  productLibrary: {
    title: "Thư viện sản phẩm",
    description: "Phân tích dữ liệu sản phẩm toàn mạng, hỗ trợ quyết định chọn sản phẩm",
  },

  // Home page
  home: {
    industryOverview: "Tổng quan ngành",
    gmv: "GMV",
    sales: "Doanh số",
    live: "Livestream",
    selfResearch: "Nghiên cứu tự chọn",
    ranking: "Bảng xếp hạng",
    monitor: "Giám sát",
    switchIndustry: "Thử chuyển ngành~",
    selectedTools: "Công cụ được chọn",
    brandGroupScreen: "Màn hình nhóm thương hiệu",
    douyinShop: "Cửa hàng Douyin",
    oceanEngine: "Ocean Engine",
    oceanResponse: "Ocean Response",
    oceanEngine2: "Ocean Engine",
    oceanStar: "Ocean Star",
    moreTools: "Thêm công cụ",
    contentCreation: "Sáng tạo nội dung",
    videoEditing: "Chỉnh sửa video",
    imageProduction: "Sản xuất hình ảnh",
    forbiddenWordDetection: "Phát hiện từ cấm",
    jianying: "Jianying",
    quickEdit: "Chỉnh sửa nhanh",
    miaoyingFactory: "Miaoying Factory",
    pr: "PR",
    templateImage: "Hình ảnh mẫu",
    batchImage: "Hình ảnh hàng loạt",
    smartCutout: "Cắt thông minh",
    manualImage: "Hình ảnh thủ công",
    chuangketie: "Chuangketie",
    inspirationSource: "Nguồn cảm hứng",
    copywritingMaterial: "Tài liệu viết quảng cáo",
    musicMaterial: "Tài liệu âm nhạc",
    creativeInspiration: "Cảm hứng sáng tạo",
    weiboHotSearch: "Tìm kiếm nóng Weibo",
    baiduTrending: "Xu hướng Baidu",
    titleRecommendation: "Đề xuất tiêu đề",
    meihuawang: "Meihuawang",
    topCopywriting: "Viết quảng cáo hàng đầu",
    musicLibrary: "Thư viện âm nhạc",
  },

  // Product Detail page
  productDetail: {
    tabs: {
      overview: "Tổng quan dữ liệu",
      videos: "Video bán hàng",
      reviews: "Phân tích đánh giá",
    },
    salesSummary: "Tổng doanh thu cao nhất trong ngày của sản phẩm này vào {date} là {amount}",
    totalSalesAmount: "Tổng doanh thu",
    totalSalesVolume: "Tổng lượng bán",
    liveStream: "Livestream",
    video: "Video",
    productCard: "Thẻ sản phẩm",
    copyTitle: "Sao chép tiêu đề",
    copyLink: "Sao chép liên kết",
    downloadImage: "Tải hình ảnh chính",
    source1688: "Nguồn 1688",
    discoveryTime: "Thời gian phát hiện",
    category: "Phân loại sản phẩm",
    shop: "Cửa hàng",
    brand: "Thương hiệu",
    shippingLocation: "Địa điểm giao hàng",
    experienceScore: "Điểm trải nghiệm",
    noImage: "Chưa có hình ảnh",
    back: "Quay lại",
    dateRanges: {
      days1: "1 ngày",
      days30: "Gần 30 ngày",
      days7: "Gần 7 ngày",
      days90: "Gần 90 ngày",
      choose: "Chọn",
    },
    toast: {
      success: "Thành công",
      titleCopied: "Đã sao chép tiêu đề",
      linkCopied: "Đã sao chép liên kết",
      imageDownloading: "Đang tải hình ảnh",
      error: "Lỗi",
      imageNotFound: "Hình ảnh không khả dụng",
    },
    modal1688: {
      title: "Nguồn hàng 1688",
      badge: "Nguồn hàng 1688",
      viewPrice: "Xem giá",
      productTitle: "QYC Quanyou Home Giường da bò hiện đại tối giản phòng ngủ đôi 116206",
      productImage: "Hình ảnh sản phẩm",
      productName: "Giường da thật phong cách Ý tối giản phòng ngủ chính",
      dropshipping: "Dropshipping một sản phẩm",
    },
  },

  // Review Analysis
  reviewAnalysis: {
    stats: {
      all: "Tất cả",
      positive: "Đánh giá tích cực",
      withImages: "Có hình ảnh",
      followUp: "Đánh giá tiếp theo",
      neutral: "Đánh giá trung bình",
      negative: "Đánh giá tiêu cực",
    },
    sectionTitle: "Nội dung đánh giá trung bình và tiêu cực",
    reviewType: "Loại đánh giá：",
    filterAll: "Tất cả",
    filterNeutral: "Đánh giá trung bình",
    filterNegative: "Đánh giá tiêu cực",
    hasReviewContent: "Có nội dung đánh giá",
    tableHeaders: {
      reviewer: "Người đánh giá",
      reviewType: "Loại đánh giá",
      reviewContent: "Nội dung đánh giá",
      sku: "SKU",
      reviewTime: "Thời gian đánh giá",
    },
    noData: "Không có dữ liệu",
  },

  // Video Product
  videoProduct: {
    filterTabs: {
      all: "Tất cả",
      video: "Video",
      graphic: "Hình ảnh và văn bản",
    },
    searchPlaceholder: "Vui lòng nhập từ khóa để tìm kiếm",
    export: "Xuất",
    tableHeaders: {
      videoInfo: "Thông tin video",
      influencerInfo: "Thông tin người ảnh hưởng",
      salesVolume: "Lượng bán",
      salesAmount: "Doanh thu",
      likes: "Số lượt thích",
      comments: "Số bình luận",
      shares: "Số lượt chia sẻ",
    },
    noData: "Không có dữ liệu~",
  },
};

